import { cn } from '@lib/cn'
import NextImage, { ImageLoader, ImageProps } from 'next/image'
import * as qs from 'query-string'
import { FC } from 'react'

type KontentImageProps = Omit<ImageProps, 'src'> & {
  src: string
}

/**
 * A Next.js Image component that loads a Kontent image.
 * @param src - The source of the image, must be a Kontent image URL
 */
export const KontentImage: FC<KontentImageProps> = ({ src, className, style, ...rest }) => {
  return (
    <div className={cn('relative flex w-full overflow-hidden', className)} style={style}>
      <NextImage
        src={src}
        loader={imageLoader}
        fill
        className="h-full w-full"
        style={{
          objectFit: style?.objectFit || 'cover',
        }}
        {...rest}
      />
    </div>
  )
}

const imageLoader: ImageLoader = ({ src, width, quality }) => {
  const url = `${src}?${qs.stringify({ w: width, q: quality, auto: 'format' })}`
  return url
}
